var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isShow)?_c('div',{staticStyle:{"width":"100%","min-height":"400px"},attrs:{"id":"main"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }